// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.channel-operator-list {
    display: flex;
    flex-direction: column;
}

.channel-operator-list__operators {
    display: flex;
    flex-direction: row;
}

.channel-operator-list__title {
    font-size: 1.8rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    text-align:start;
}

.channel-operator-list__operator-avatar {
    width: 6.4rem !important;
    height: 6.4rem !important;
    border-radius: 50%;
}

    .channel-operator-list__operator-avatar svg {
        width: 100% !important;
        height: 100% !important;
    }

.channel-operator-list__operator-name {
    position: relative;
    top: -0.2rem;
    left: 0;
    text-align: center;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
            line-clamp: 2; 
    -webkit-box-orient: vertical;
}

.channel-operator-list__btn-add-operator {
    background: none;
    min-width: 6.4rem;
    height: 6.4rem;
    border-radius: 50%;
    margin: 0px 0.4rem 0px 0.4rem;
    cursor: pointer;
    box-shadow: 0px 0px 2px 0px #4b4b4b;
    border: none;
}

.channel-operator-list__btn-add-operator:hover {
    transition: 0.5ms;
    background-color: rgba(150, 150, 150, 0.3);
}

.channel-operator-list__btn-add-operator:focus {
    background: none;
    box-shadow: none;
}

.channel-operator-list__operator {
    margin: 0 0.4rem;
    width: 10rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/app/channel/channel-main/channel-list/channel-item/channel-operator-list/ChannelOperatorList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;AACtB;;IAEI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB,EAAE,4BAA4B;YAC3C,aAAa;IACrB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;IACf,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB","sourcesContent":[".channel-operator-list {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.channel-operator-list__operators {\r\n    display: flex;\r\n    flex-direction: row;\r\n}\r\n\r\n.channel-operator-list__title {\r\n    font-size: 1.8rem;\r\n    font-weight: 700;\r\n    margin-bottom: 0.5rem;\r\n    text-align:start;\r\n}\r\n\r\n.channel-operator-list__operator-avatar {\r\n    width: 6.4rem !important;\r\n    height: 6.4rem !important;\r\n    border-radius: 50%;\r\n}\r\n\r\n    .channel-operator-list__operator-avatar svg {\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n    }\r\n\r\n.channel-operator-list__operator-name {\r\n    position: relative;\r\n    top: -0.2rem;\r\n    left: 0;\r\n    text-align: center;\r\n    word-break: break-word;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: -webkit-box;\r\n    -webkit-line-clamp: 2; /* number of lines to show */\r\n            line-clamp: 2; \r\n    -webkit-box-orient: vertical;\r\n}\r\n\r\n.channel-operator-list__btn-add-operator {\r\n    background: none;\r\n    min-width: 6.4rem;\r\n    height: 6.4rem;\r\n    border-radius: 50%;\r\n    margin: 0px 0.4rem 0px 0.4rem;\r\n    cursor: pointer;\r\n    box-shadow: 0px 0px 2px 0px #4b4b4b;\r\n    border: none;\r\n}\r\n\r\n.channel-operator-list__btn-add-operator:hover {\r\n    transition: 0.5ms;\r\n    background-color: rgba(150, 150, 150, 0.3);\r\n}\r\n\r\n.channel-operator-list__btn-add-operator:focus {\r\n    background: none;\r\n    box-shadow: none;\r\n}\r\n\r\n.channel-operator-list__operator {\r\n    margin: 0 0.4rem;\r\n    width: 10rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    align-items: center;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
